<template>
    <div>
        <vs-table
            :data="currentOrderedItems"
            no-data-text="Aucune donnée disponible"
            style="width:100%"
        >
            <template slot="thead">
                <vs-th style="width: 15px"></vs-th>
                <vs-th v-for="column in table.columns" :key="column.name">
                    {{ column.label }}
                </vs-th>
            </template>
            <template slot-scope="{ data }">
                <tr
                    v-for="(item, i) in data"
                    :key="i"
                    :data="item"
                    :class="!!dragging && dragging.id == item.id ? 'dragging' : 'waiting-drag'"
                >
                     <vs-td>
                        <div
                            class="drag-icon"
                            draggable="true"
                            @dragstart="dragStart(item, $event)"
                            @dragover="dragOver(item.order, $event)"
                            @drop="drop(item.order, $event)"
                        ></div>
                    </vs-td>
                    <vs-td v-for="column in table.columns" :key="column.name" :data="data_get(item, column.name)">
                        {{ data_get(item, column.name) }}
                    </vs-td>
                </tr>
            </template>
        </vs-table>
    </div>
</template>

<script>
import {data_get} from '@assets/utils/helpers/data_get.js'
export default {
    name: 'Draggable',
    props: {
        data: {
            type: Array,
            required: true
        },
        table: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            data_get,
            dragging: null,
            orderChanged: false,
            currentOrderedItems: [],
        };
    },
    methods: {
        dragStart(item, event) {
            this.dragging = item;
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.dropEffect = "move";
            event.dataTransfer.setData('text', item.id);
        },
        dragEnd() {
            this.dragging = null;
        },
        dragOver(to, event) {
            event.preventDefault();
            event.dataTransfer.dropEffect = 'move';

            // Trouver l'index de l'élément déplacé et de la cible
            const fromIndex = this.currentOrderedItems.findIndex(i => i.id === this.dragging.id);
            const toIndex = this.currentOrderedItems.findIndex(i => i.order === to);

            // Ne rien faire si on survole la même case ou si déjà à la bonne place
            if (fromIndex === toIndex || toIndex === -1) return;

            // Déplacer l'élément dans le tableau
            const moved = this.currentOrderedItems.splice(fromIndex, 1)[0];
            this.currentOrderedItems.splice(toIndex, 0, moved);

            // Réaffecter les ordres
            this.currentOrderedItems.forEach((item, idx) => {
                item.order = idx + 1;
            });

            this.orderChanged = true;
        },
        drop(to, event) {
            event.preventDefault();

            if (this.orderChanged) {

                const updated = [];
                
                // Compilation des éléments mis à jour
                // this.data.forEach(item => {
                //     const updatedItem = this.currentOrderedItems.find(i => i.id === item.id);
                //     if (updatedItem && updatedItem.order !== item.order) {
                //         updated.push({ ...updatedItem });
                //     }
                // });

                this.currentOrderedItems.forEach((item, i) => {
                    item.order = i + 1

                    updated.push({ ...item });
                })
                
                this.$emit('updated', updated);
            }
        }
    },
    created() {
        const data = _.cloneDeep(this.data);
        this.currentOrderedItems = data.sort((a, b) => a.order - b.order);
    }
};
</script>